module.exports = __webpack_public_path__ + "media/images/icon-arrow-back-cd276e901ecb4a3e184ea09d16698f5f.png";